import Calendar from "@mui/icons-material/Event";
import { DateRangePicker } from "rsuite";
import "rsuite/dist/rsuite.min.css";
import "./DateRangePicker.scss";
import { countryWiseDateRangeFormate } from "../util/DateTimeUtils";

const DateRangeCtrl = (props: any) => {
  const { placement, showHeader, name, format, value, onChange, placeholder } = props;
  const dateFormate: string = countryWiseDateRangeFormate();

  return (
    <div className="dateRange">
      <DateRangePicker
        {...props}
        key={props}
        ranges={[]}
        size="md"
        block
        caretAs={Calendar}
        name={name}
        format={format || dateFormate}
        placeholder={placeholder || `${dateFormate?.toUpperCase()} ~ ${dateFormate?.toUpperCase()}`}
        showHeader={showHeader || true}
        value={value || null}
        onChange={onChange}
        cleanable={false} // This removes the close icon
        placement={placement || "bottomStart"}
      />
    </div>
  );
};

export default DateRangeCtrl;




//  {/* This is kept for future reference */}
// import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
// import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
// import { DateRangePicker } from "@mui/x-date-pickers-pro/DateRangePicker";
// import { SingleInputDateRangeField } from "@mui/x-date-pickers-pro/SingleInputDateRangeField";
// import { DemoContainer } from "@mui/x-date-pickers/internals/demo";

// const DateRangeCtrl = (props: any) => {
//   return (
//     <div className="date-picker doubleDatePicker">
//       <LocalizationProvider dateAdapter={AdapterDayjs}>
//         <DemoContainer components={["SingleInputDateRangeField"]}>
//           <DateRangePicker
//             {...props}
//             sx={{ height: "38px" }}
//             slots={{ field: SingleInputDateRangeField }}
//             format="DD/MM/YYYY"
//             value={props?.value}
//             onChange={props?.onChange}
//             minDate={props?.minDate}
//             maxDate={props?.maxDate}
//             slotProps={{
//               textField: {
//                 InputProps: { endAdornment: <Calendar /> },
//               },
//             }}
//           />
//         </DemoContainer>
//       </LocalizationProvider>
//     </div>
//   );
// };

// export default DateRangeCtrl;
